import TopBar from './components/TopBar';
import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import EditorPicks from './components/EditorPicks';
import CategoryRail from './components/CategoryRail';
import LibraryGrid from './components/LibraryGrid';
import RankingSection from './components/RankingSection';
import TalkSection from './components/TalkSection';
import ColumnsSection from './components/ColumnsSection';
import TagCloud from './components/TagCloud';
import SubscribeBand from './components/SubscribeBand';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <TopBar />
      <SiteHeader />
      <main>
        <HeroSection />
        <EditorPicks />
        <CategoryRail />
        <LibraryGrid />
        <RankingSection />
        <TalkSection />
        <ColumnsSection />
        <TagCloud />
        <SubscribeBand />
      </main>
      <SiteFooter />
    </div>
  );
}